/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
let uiKitInstanceId = null;
let count = 0;
const GLOBAL_INSTANCE_KEY = '__ui_kit_instance_count__';

/**
 * Хук для создания опциональных идентификаторов на клиенте
 */
function useId(id) {
  const [defaultId, setDefaultId] = React.useState(id);
  React.useEffect(() => {
    if (!defaultId) {
      if (uiKitInstanceId === null) {
        window[GLOBAL_INSTANCE_KEY] = window[GLOBAL_INSTANCE_KEY] || 0;
        uiKitInstanceId = window[GLOBAL_INSTANCE_KEY]++;
      }
      setDefaultId("ui-kit-".concat(uiKitInstanceId, "-").concat(count++));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Сначала попытаемся вернуть id из аргумента
  // Потому что обновление через эффект требует лишнего ререндера
  return id || defaultId;
}
export { useId };